import React from 'react';
import { Field } from 'formik';

import Label from '@dashboard/components/Form/components/Label';

const RadioGroup = ({ name, children }) => {
  return (
    <div role="radiogroup" aria-labelledby={name} className="space-y-1">
      {children}
    </div>
  );
};

const RadioWrapper = ({ children }) => {
  return <div className="flex items-center gap-x-1.5">{children}</div>;
};

const RadioLabel = ({ children, ...props }) => {
  return (
    <Label isInline className="mb-0" {...props}>
      {children}
    </Label>
  );
};

const RadioInput = ({ value, name, disabled, ...props }) => (
  <Field
    type="radio"
    className="h-[18px] w-[18px] text-chocolate-600 border-gray-300 focus:ring-gray-300 focus:ring-2"
    name={name}
    value={value}
    disabled={disabled}
    {...props}
  />
);

const Radio = {
  Group: RadioGroup,
  Wrapper: RadioWrapper,
  Label: RadioLabel,
  Input: RadioInput,
};

export default Radio;
